export default {
  unsubscribeLink: 'Unregister',
  detailsLink: ' Contest details',
  unsubscribeConfirmationTitle: 'Sure you want to unsubscribe?',
  detailsModalTitle: 'Contest details',
  detailsModalClose: 'Close',
  contestRulesUriLabel: 'See contest rules.',
};
